import React from 'react';

/** "16:9" → CSS aspect-ratio "16 / 9" */
export function toCssAspectRatio(ratio) {
    if (!ratio || typeof ratio !== 'string') return '1 / 1';
    const parts = ratio.split(':').map((x) => Number(String(x).trim()));
    if (parts.length !== 2 || !parts[0] || !parts[1]) return '1 / 1';
    return `${parts[0]} / ${parts[1]}`;
}

/**
 * Серый placeholder под генерируемое изображение
 * с соотношением сторон ожидаемого ответа и shimmer-анимацией.
 */
const ImagePlaceholder = ({ aspectRatio = '1:1', className = '' }) => (
    <div
        className={`bananas-img-placeholder bananas-img-preview relative w-full overflow-hidden rounded-xl ${className}`}
        style={{ aspectRatio: toCssAspectRatio(aspectRatio) }}
        role="status"
        aria-label="Генерация изображения"
    >
        <div className="bananas-img-placeholder-base absolute inset-0" />
        <div className="bananas-img-placeholder-shimmer absolute inset-0" aria-hidden />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
            <span className="bananas-img-placeholder-spinner" aria-hidden />
            <span className="bananas-img-placeholder-caption">Генерация…</span>
        </div>
    </div>
);

export default ImagePlaceholder;
